module.exports = __webpack_public_path__ + "static/media/customer-7.d41acc58.jpg";